import React, {Component}  from 'react';
import moment from "moment";
import axios from 'axios';
import {Link} from "react-router-dom";
// import Countdown from 'react-countdown-now';

import './Referencia.css';
import Alert from '../../modal/alert'

class Referenciage extends Component {
  constructor(props){
    super(props);
    this.state = {
        nombredr: '',
        colega: '',
        fechad: moment().format('YYYY-MM-DD'),
        referido:'',
        presenta4:'',
        practicado4:'',
        mensajealerta:false,
        opfirma:'NO',
        cedula:'',
    }
  }
  onChange(e) {
    //console.log(e.target.name)
    this.setState({
        [e.target.name]: e.target.value
    })
  }
    
  guardar=()=>{
    if (this.state.nombredr.length>0) {
        let data = new FormData();
        data.append('cedula', this.state.cedula);
        data.append('nombredr', this.state.nombredr);
        data.append('colega', this.state.colega);
        data.append('referir', this.state.referido);
        data.append('presenta', this.state.presenta4);
        data.append('practicado', this.state.practicado4);
        data.append('desde', this.state.fechad);
        data.append('tipoinforme', 'REFERIDOR');
        data.append('firma', this.state.opfirma);
        data.append('boton', 'Adicionar');

        axios({
            method:'post',
            url:'https://institutobilinguelasnaciones.com/clinicoIBLN/informepacientesPHP.php',
            data: data
        })
        .then(res => {
            //console.log(res.data.variable1)
            if (res.data.variable1) {
                this.setState({
                    mensajealerta: true,
                    tituloM: 'Menu Envio de Correos',
                    cuerpoM: 'El correo se envio exitosamente a el paciente',
                })
                
            } else {
                this.setState({
                    mensajealerta: true,
                    tituloM: 'Menu Envio de Correo',
                    cuerpoM: 'Hubo un error, No se envio el correo a el paciente, verifique por favor',
                })
            }
        })
    }else {
        this.setState({
            mensajealerta: true,
            tituloM: 'Menu Envio de Correo',
            cuerpoM: 'Debe seleccionar un paciente',
        })
    }
}  
 
imprimir=()=>{
    let data = new FormData();
    data.append('nombre', this.state.nombredr);
    data.append('colega', this.state.colega);
    data.append('referir', this.state.referido);
    data.append('presenta', this.state.presenta4);
    data.append('practicado', this.state.practicado4);
    data.append('desde', this.state.fechad);
    data.append('firma', this.state.opfirma);
    axios({
        method:'post',
        url:'https://institutobilinguelasnaciones.com/clinicoIBLN/fpdf/reportes/referidoPHP.php',
        responseType:'arraybuffer',
        data: data
      })
        .then(function(response) {
          let blob = new Blob([response.data], { type:   'application/pdf' } )
          var fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
        //   let link = document.createElement('a')
        //   link.href = window.URL.createObjectURL(blob)
        //   link.download = 'reporte.pdf'
        //   link.click()
         
      });

    // axios.post('https://institutobilinguelasnaciones.com/clinica/fpdf/reportes/infocartaPHP.php')
    // .then(res => {
    //     console.log(res.data)
     
    // })    

}

consultar(e) {
    if (parseFloat(this.state.cedula) > 0 || parseFloat(e)>0) {
        let jcedul=0;
        if (parseFloat(this.state.cedula) > 0){
            jcedul=parseFloat(this.state.cedula);
        } 
        if (parseFloat(e)>0){
            console.log("xpaso1: "+parseFloat(e));
            jcedul=parseFloat(e);
        } 
        axios.post('https://institutobilinguelasnaciones.com/clinicoIBLN/historia.php/?cedula=' + jcedul + '&boton=Consultar')
        //console.log(('https://institutobilinguelasnaciones.com/clinicoIBLN/historia.php/?cedula=' + this.state.cedula + '&boton=Consultar'))    
        .then(res => {
                if (res.data) {
                    this.setState({
                        clientetrue:false,
                        citaOn:false,
                        cedula: String(res.data.variable1),
                        referido: String(res.data.variable3)+" "+String(res.data.variable4),
                    })
                } else {
                    this.setState({
                        mensajealerta: true,
                        tituloM: 'Menu Referencia Medica',
                        cuerpoM: 'No se encontro la cedula que se desea consultar, verifique Gracias...',
                     })
                }
            })
    } else {
        this.setState({
            mensajealerta: true,
            tituloM: 'Menu Referencia Medica',
            cuerpoM: 'Debe Introducir un numero de cedula para poder realizar una consulta Gracias...',
        })

    }
}


handleClose = () => {
    this.setState({ mensajealerta: false })
  }


  render(){
      return(
        <div className="row">  
            <div className="cont-quimioc col-12">

                {this.state.mensajealerta === true &&
                    <Alert
                    tituloMensaje={this.state.tituloM} 
                    cuerpoMensaje={this.state.cuerpoM}
                    open={this.state.mensajealerta}
                    handleClose={this.handleClose}
                    />
                }  

                <div className="row">
                    <div className="cont-tituloquimioc col-12">    
                        <span className="tituloquimioc">Informe Referidor</span>
                        <Link to="/"><span className="titulo-cerrarquimioc">X</span></Link>
                    </div>
                </div>
                <div className='row'>
                    <div className="cont-opcion col-3">
                        <label className="opcion">Cedula.</label>
                        <input
                            
                            className="form-control"
                            type="text"
                            name="cedula"
                            id="cedula"
                            autoComplete="off"
                            pattern="[0-9] required"
                            value={this.state.cedula}
                            onChange={this.onChange.bind(this)}
                            onKeyPress={event => { if (event.key === 'Enter') {this.consultar()} }}
                        />
                        <i className="icono-izquierdac fa fa-search" onClick={this.consultar.bind(this)}> </i>
                    </div>
                </div>    
            
                <div className='row'>
                    <div className="cont-opcion col-6">
                        <label className="opcion" >Nombre del Dr.</label>
                        <input
                            className="form-control"
                            type="text"
                            name="nombredr"
                            id="nombredr"
                            autoComplete="off"
                            value={this.state.nombredr}
                            onChange={this.onChange.bind(this)}
                        />
                    </div>
                    <div className="cont-opcion col-6">
                        <label className="opcion" >Estimado Colega.</label>
                        <input
                            className="form-control"
                            type="text"
                            name="colega"
                            id="colega"
                            autoComplete="off"
                            value={this.state.colega}
                            onChange={this.onChange.bind(this)}
                        />
                    </div>
                </div>    
                <div className='row'>
                    <div className="cont-opcion col-6">
                        <label className="opcion" >Le Refiero A.</label>
                        <input
                            className="form-control"
                            type="text"
                            name="referido"
                            id="referido"
                            autoComplete="off"
                            value={this.state.referido}
                            onChange={this.onChange.bind(this)}
                        />
                    </div>
                    <div className="cont-opcion col-2">
                        <label className="opcion" >Fecha.</label>
                        <input  
                            className="form-control"  
                            name="fechad"
                            id="fechad"
                            type="date" 
                            value={ moment(this.state.fechad).format("YYYY-MM-DD") } 
                            onChange={ this.onChange.bind(this) } 
                        />
                    </div>
                </div>    
                <div className='row'>
                    <div className="cont-opcion col-6">
                        <label className="opcion" >Quien Presenta.</label>
                        <textarea
                            className="form-control"
                            name="presenta4"
                            id="presenta4"
                            rows="3"
                            cols="135"
                            value={this.state.presenta4}
                            onChange={this.onChange.bind(this)}
                        />
                    </div>
                    <div className="cont-opcion col-6">
                        <label className="opcion" >Para que le sea practicado.</label>
                        <textarea
                            className="form-control"
                            name="practicado4"
                            id="practicado4"
                            rows="3"
                            cols="135"
                            value={this.state.practicado4}
                            onChange={this.onChange.bind(this)}
                        />
                    </div>
                    <div className="representante col-5">
                        <label className="labelantecedentesescolar">Imprimir Firma. </label>
                        <label className="titulosn">
                            <input
                                type="radio"
                                className="opfirmasi"
                                name="opfirma"
                                id="opfirma"
                                value="SI"
                                checked={this.state.opfirma === 'SI'}
                                onChange={this.onChange.bind(this)}
                            />
                        SI</label>
                        <label className="titulosn">
                            <input
                                type="radio"
                                className="opfirmano"
                                name="opfirma"
                                id="opfirma"
                                value="NO"
                                checked={this.state.opfirma === 'NO'}
                                onChange={this.onChange.bind(this)}
                            />
                        NO</label>
                    </div>

                </div>
                <div className='row'>    
                   
                        <div className="botonesgeneral col-12">
                            <button className="botongr" onClick={this.guardar.bind(this)}>Enviar al Correo</button>
                            <button className="botongr" onClick={this.imprimir.bind(this)}>Imprimir</button>
                        </div>
                </div>
            </div>
        </div>
    )
  }
}
export default Referenciage;  